import useSwr from 'swr'
import { API_URL } from '@/utils/constants'

export interface Acquisitions {
	/** inscription id -> ISO time of the latest purchase on Ordinals Wallet */
	inscriptions: Record<string, string>
	/** collection slug (rune-…, alkane-…, brc20-…, tap-…) -> ISO time of the latest purchase */
	tokens: Record<string, string>
}

const fetcher = (url: string) => fetch(url).then((r) => r.json())

/**
 * When this wallet bought what, so the wallet page can put the newest
 * purchases first. Items that arrived by mint or transfer have no entry.
 */
export default function useAcquisitions(address?: string | null) {
	const { data } = useSwr<Acquisitions>(
		address ? `${API_URL}/wallet/${address}/acquisitions` : null,
		fetcher,
		{ revalidateOnFocus: false, dedupingInterval: 30_000 }
	)
	return data ?? null
}

export function acquiredAtMs(iso: string | undefined): number {
	if (!iso) return 0
	const t = Date.parse(iso)
	return Number.isFinite(t) ? t : 0
}
